import React, { useState } from 'react';
import { bool, func, object } from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
// import template from 'url-template';

import { setProfile } from '../../actions/profileActions';

import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import classes from './ProfilesTableRowMenu.module.css';


const ProfilesObjectsTableRowMenu = ({
    hidden,
    history,
    location,
    object,
    onDelete,
    onManage
}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    if (hidden) {
        return null;
    }

    function handleOpen(event) {
        setAnchorEl(event.currentTarget);
    }

    function handleClose() {
        setAnchorEl(null);
    }

    function handleManage() {
        onManage(object);
        handleClose();
    }

    function handleDelete() {
        onDelete(object);
        handleClose();
    }

    return (
        <React.Fragment>
            <Button
                aria-owns={open ? 'render-props-menu' : undefined}
                aria-haspopup="true"
                onClick={handleOpen}
                className={classes.contextMenuButton}
            >
                <i className="fas fa-ellipsis-h" />
            </Button>
            <Menu
                id="render-props-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                className={classes.contextMenu}
            >
                <MenuItem
                    data-test-id="manage"
                    onClick={handleManage}
                >
                    <img
                        alt=""
                        className={classes.contextIcon}
                        src="/assets/images/SettingsFlat.svg"
                    />
                    Manage
                </MenuItem>
                <MenuItem
                    data-test-id="delete"
                    onClick={handleDelete}
                >
                    <img
                        alt=""
                        className={classes.contextIcon}
                        src="/assets/images/deleteIconColor.svg"
                    />
                    Delete
                </MenuItem>
            </Menu>
        </React.Fragment>
    );
};

ProfilesObjectsTableRowMenu.defaultProps = {
    hidden:     false,
    onDelete:   () => {},
    onManage:   () => {},
    setProfile: () => {}
};

ProfilesObjectsTableRowMenu.propTypes = {
    profile:    object,
    hidden:     bool,
    history:    object,
    location:   object,
    onDelete:   func,
    onManage:   func,
    setProfile: func
};

const mapDispatchToProps = {
    setProfile
};

export default withRouter(
    connect(null, mapDispatchToProps)(ProfilesObjectsTableRowMenu)
);
